import store from '@/store'

export const claimClaimant = (to, from, next) => {
  if (store.state.claims.claimDetail.commonInfo.statusCode === 'N') {
    const { claimLifeCycle } = store.state.claims.claimDetail
    // claimClaimant is 1
    if (claimLifeCycle < 1) {
      // For Claimant, can only go back to Claim New
      next({ name: 'claimEntry' })
    } else {
      next()
    }
  } else {
    next({ name: 'claimEntry' })
  }
}

export const claimItem = (to, from, next) => {
  if (store.state.claims.claimDetail.commonInfo.statusCode === 'N') {
    const { claimLifeCycle } = store.state.claims.claimDetail
    // claimItem is 2
    if (claimLifeCycle < 2) {
      if (claimLifeCycle === 1) {
        next({ name: 'claimDetail' })
      } else {
        next({ name: 'claimEntry' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'claimEntry' })
  }
}

export const claimReserve = (to, from, next) => {
  if (store.state.claims.claimDetail.commonInfo.statusCode === 'N') {
    const { claimLifeCycle } = store.state.claims.claimDetail
    // claimReserve is 3
    if (claimLifeCycle < 3) {
      if (claimLifeCycle === 1) {
        next({ name: 'claimDetail' })
      } else if (claimLifeCycle === 2) {
        next({ name: 'claimDetailItem' })
      } else {
        next({ name: 'claimEntry' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'claimEntry' })
  }
}

export const claimSummary = (to, from, next) => {
  if (store.state.claims.claimDetail.commonInfo.statusCode === 'N') {
    const { claimLifeCycle } = store.state.claims.claimDetail
    // claimSummary is 4
    if (claimLifeCycle < 4) {
      if (claimLifeCycle === 1) {
        next({ name: 'claimDetail' })
      } else if (claimLifeCycle === 2) {
        next({ name: 'claimDetailItem' })
      } else if (claimLifeCycle === 3) {
        next({ name: 'claimDetailReserve' })
      } else {
        next({ name: 'claimEntry' })
      }
    } else {
      next()
    }
  } else {
    next({ name: 'claimEntry' })
  }
}
